import { useState } from 'react';
import '../assets/css/animated-buttons.css';

const AnimatedAddToCartButton = ({ onClick, disabled = false, className = '' }) => {
  const [isAdding, setIsAdding] = useState(false);

  const handleClick = async (e) => {
    if (disabled || isAdding) return;

    e.stopPropagation(); // Prevent card click when clicking button
    setIsAdding(true);

    try {
      await onClick(e);

      // Reset after animation
      setTimeout(() => {
        setIsAdding(false);
      }, 1500);
    } catch (error) {
      setIsAdding(false);
    }
  };

  return (
    <button
      className={`cart-button ${isAdding ? 'adding success' : ''} ${disabled ? 'disabled' : ''} ${className}`}
      onClick={handleClick}
      disabled={disabled || isAdding}
    >
      <span className="cart-icon">
        <svg
          strokeLinejoin="round"
          strokeLinecap="round"
          strokeWidth="2"
          stroke="currentColor"
          fill="none"
          viewBox="0 0 24 24"
          height="20"
          width="20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle r="1" cy="21" cx="9"></circle>
          <circle r="1" cy="21" cx="20"></circle>
          <path
            d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"
          ></path>
        </svg>
      </span>
      {isAdding ? 'Adding...' : 'Add to Cart'}
      <div className="progress-bar"></div>
    </button>
  );
};

export default AnimatedAddToCartButton;
